import { apiClientV2 } from '@/services/rest-api-webhook/apiClient'
const baseURL = process.env.VUE_APP_REST_API_WEBHOOK
const baseEndpoint = '/events' 

export const get = async () => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: baseEndpoint,
  })

  return response?.data
}